<!-- 组件 -->
<template>
    <el-dialog ref="historyDialog" :visible.sync="historyDialog" @opened="opened" width="70vw" append-to-body custom-class="hs-dialog" top="20vh">
        <div slot="title" class="hs-dialog-title">
            数据历史变化曲线
        </div>
        <div>
            <div class="xrow ai-c">
                <p class="fw-bd lh34 mgr15">起止时间</p>
                <el-date-picker v-model="queryDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                </el-date-picker>
                <el-button type="primary" icon="el-icon-search" class="mgl15" @click="query">查询</el-button>
            </div>
            <historychart ref="historyChart"></historychart>
        </div>
    </el-dialog>
</template>

<script>
/**
 *
 */
import { formatDate } from '../../common/util.js'
import historychart from './components/historychart'
export default {
    name: 'historydialog',
    components: { historychart },
    props: {},
    data() {
        return {
            nodeid: null,
            queryName:"",
            valueParamList:[],
            type:"",
            historyDialog: false,
            queryDate: [
                new Date().getTime() - 3600 * 1000 * 24 * 30,
                new Date().getTime()
            ],
            pickerOptions: {}
        }
    },
    methods: {
        show(nodeid,queryName,valueParamList,type) {
           // console.log('history', nodeid)
            this.nodeid = nodeid;
            this.queryName=queryName;
            this.valueParamList=valueParamList;
            this.type=type;
            this.historyDialog = true
        },
        close() {
            this.historyDialog = false
        },
        opened() {
            this.$refs.historyChart.loadData(
                this.nodeid,
                this.queryDate == null
                    ? ''
                    : formatDate(this.queryDate[0], 'yyyy-MM-dd'),
                this.queryDate == null
                    ? ''
                    : formatDate(this.queryDate[1], 'yyyy-MM-dd'),
                    this.queryName,
                    this.valueParamList,
                    this.type
            )
        },
        query() {
            this.$refs.historyChart.loadData(
                this.nodeid,
                this.queryDate == null
                    ? ''
                    : formatDate(this.queryDate[0], 'yyyy-MM-dd'),
                this.queryDate == null
                    ? ''
                    : formatDate(this.queryDate[1], 'yyyy-MM-dd'),
                    this.queryName,
                    this.valueParamList,
                    this.type
            )
        }
    }
}
</script>
<style lang='scss' scoped>
</style>
